export enum BrandId {
  Groundfloor = 'groundfloor',
  LastK = 'lastk'
}

export interface Brand {
  id: BrandId;
  name: string;
  privacyUrl?: string;
  contactUrl?: string;
}

const brands = [
  {
    id: BrandId.Groundfloor,
    name: 'Groundfloor',
    privacyUrl: 'https://groundfloordelivery.com/privacy-policy',
    contactUrl: 'https://groundfloordelivery.com/contact-us'
  },
  {
    id: BrandId.LastK,
    name: 'LastK',
    contactUrl: 'https://clickandcollectlockers.com.au/contact/'
  }
];

export function getBrand(brandId: BrandId | string | undefined): Brand {
  if (!brandId) {
    return brands[0];
  }
  return brands.find((brand) => brand.id === brandId) ?? brands[0];
}

export function getDefaultBrandId(): BrandId {
  return BrandId.Groundfloor;
}

export function getDefaultBrand(): Brand {
  return getBrand(getDefaultBrandId());
}
